import React from "react";

import PageWrapper from "../components/PageWrapper";
import { Box } from "../components/Core";
import Contact from "../sections/others/Contact";
import Seo from "../components/Seo";

const ContactPage = () => {
  return (
    <>
      <Seo
        title="Contact — Book a 30-min Intro"
        description="Tell us what's broken. 30-minute call. No pitch deck. cal.com/fabio-dioscuro/intro"
        pathname="/contact"
      />
      <PageWrapper darkTheme>
        <Box pt={4}>
          <Contact />
        </Box>
      </PageWrapper>
    </>
  );
};

export default ContactPage;
